<template>
  <div v-if="!isLoading">
    <portal-target name="agreement-popup"></portal-target>
    <voucher-banner banner-id="voucher_index"/>
    <div :class="'voucher-wrap ' + (device ===  'ios' ? 'voucher-ios' : '')">
      <nav class="ticket-tab" v-if="isTabView">
        <ul>
          <li :class="selectedTabClass('wavve')">
            <a href="#" @click.prevent="moveToVoucherTab('wavve')">웨이브</a>
          </li>
          <li :class="selectedTabClass('partner')">
            <a href="#" @click.prevent="moveToVoucherTab('partner')">제휴</a>
          </li>
        </ul>
      </nav>
      <section :class="sectionClass">
        <h2 class="page-text">방송/영화/해외 시리즈 무제한!</h2>
        <ul class="voucher-list">
          <li v-for="(voucher, index) in voucherList" :key="'wavve_voucher_' + index">
            <div class="inner-wrap">
              <div class="label-area">
                <h3>
                  <span>{{ getValue(voucher, 'product_name') }}</span>
                  <span v-if="isInUse(voucher)" class="icon">이용중</span>
                  <span v-if="isRecommendation(voucher)" class="icon icon-supplant">추천</span>
                </h3>

                <div class="price-area" v-if="voucherType === 'partner'">
                  <span class="before-price" v-if="getValue(voucher, 'displayamount') !== ''">&#65510;{{ setNumberCommas(getValue(voucher, 'displayamount')) }}</span>
                  <button type="button" @click="purchase(voucher, {productid: getValue(voucher, 'productid')})"
                          ref="purchaseButton"
                          :id="getValue(voucher, 'productid')"
                          class="btn">
                    &#65510;{{ setNumberCommas(getValue(voucher, 'amount')) }}
                  </button>
                </div>
              </div>
              <voucher-table-list :support-device="getValue(voucher, 'mobile_support_device')"
                                  :quality="getValue(voucher, 'quality')"
                                  :concurrency="getValue(voucher, 'concurrency')" />

              <div v-if="voucherType === 'wavve'" class="button-area">
                <button type="button" @click="purchase(voucher,amountInfoData)"
                        v-for="(amountInfoData, index) in purchaseAmountInfoList(voucher)"
                        :class="buttonClass(getAmountDataValue(amountInfoData, 'productid'))"
                        :key="'voucher_button_' + index">
                  <span class="month">
                    <span>{{getAmountDataValue(amountInfoData, 'use_day')}}</span>
                    <span class="discount" v-if="isDiscount(amountInfoData)">{{getAmountDataValue(amountInfoData, 'discount_rate')}}%</span>
                  </span>
                  <span class="price">
                    <span>&#65510;{{ setNumberCommas(getAmountDataValue(amountInfoData, 'amount')) }}</span>
                    <span class="summary" v-if="isMonthAmount(amountInfoData)">(월 &#65510;{{ setNumberCommas(getAmountDataValue(amountInfoData, 'month_amount')) }})</span>
                  </span>
                </button>
              </div>
            </div>
          </li>
        </ul>
        <div class="common-benefit">
          <h4>이용권 공통 혜택</h4>
          <ul class="common-benefit-list">
            <li>
              <span>VOD 30만편 이상&lpar;방송/해외시리즈/키즈/애니메이션 등&rpar; 제공</span>
            </li>
            <li>
              <span>LIVE 100개 이상 채널 시청</span>
            </li>
            <li>
              <span>영화 6천편 무제한 시청&lpar;영화플러스 개별구매 별도&rpar;</span>
            </li>
            <li>
              <span>다운로드 무제한 &lpar;PC 30회 제한&rpar; & QVOD / 타임머신 이용 </span>
            </li>
          </ul>
        </div>
      </section>
      <bottom-guide-ios id="bottomGuide" v-if="device === 'ios'"/>
      <voucher-guide v-else/>
    </div>
  </div>
</template>

<script>
import { VoucherService } from '@/common/api/api.service'
import VoucherGuide from '@/components/lnb/voucher/VoucherGuide'
import utils from '@/common/util/utils'
import VoucherBanner from '@/components/lnb/voucher/VoucherBanner'
import BottomGuideIos from '@/components/lnb/voucher/BottomGuideIos'
import { get, findIndex } from 'lodash'
import { voucherPurchase } from '@/common/util/common'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
import {
  PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE,
  PRODUCT_TYPE_SUBSCRIPTION
} from '@/common/constant'
import VoucherTableList from '@/components/lnb/voucher/VoucherTableList'
import braze from '@/common/util/braze'
import { normalizePurchaseParams, getPurchaseProperties } from '@/common/util/braze.util'

export default {
  components: {
    VoucherGuide,
    VoucherBanner,
    BottomGuideIos,
    VoucherTableList
  },
  data () {
    return {
      voucherList: [],
      voucherType: 'wavve',
      dataList: [],
      device: utils.cookies.getDevice(),
      isLoading: true,
      recommendVoucher: 'standard',
      selectedProductId: null
    }
  },
  computed: {
    isTabView () {
      return utils.cookies.getDevice() !== DEVICE_TYPE_IOS && utils.getPgName() !== PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE
    },
    sectionClass () {
      return this.voucherType === 'partner' ? 'partner' : ''
    }
  },
  methods: {
    setNumberCommas (data) {
      if (!data) return 0
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    setData () {
      this.isLoading = true
      this.voucherType = get(this.$route, 'query.voucherType', 'wavve')
      const store = this.device === DEVICE_TYPE_ANDROID ? utils.getPgName() : 'wavve'
      VoucherService.getVoucherPurchase({ store, device: this.device }).then(({ data }) => {
        this.dataList = JSON.parse(get(data, 'data.json', ''))
        const wavveVoucherIndex = findIndex(this.dataList, { passgroup_type: 'wavve' })
        const partnerVoucherIndex = findIndex(this.dataList, { passgroup_type: 'partner' })
        this.voucherList = get(this.dataList, [this.voucherType === 'wavve'
          ? wavveVoucherIndex
          : partnerVoucherIndex, 'productgroups', '0', 'products'], [])
        this.isLoading = false
      })
    },
    buttonClass (productId) {
      const defaultClass = 'btn'
      return productId === this.selectedProductId ? `${defaultClass} selected` : defaultClass
    },
    purchase (voucher, productInfo) {
      const productId = get(productInfo, 'productid', '')
      this.selectedProductId = productId
      const concurrency = get(voucher, 'concurrency.0', '')
      this.recommendVoucher = get(concurrency, 'product_name', '').toLowerCase()
      const isExternal = get(concurrency, 'is_product_external', 'n').toUpperCase() === 'Y'
      const linkTarget = get(concurrency, 'external_link_target', '')
      if (isExternal) {
        if (this.device === DEVICE_TYPE_ANDROID) {
          location.href = get(concurrency, 'external_link_android', '')
        } else {
          window.open(get(concurrency, 'external_link_mobile', ''), linkTarget)
        }
      } else {
        let productTypeForGoogleIAP = ''
        if (utils.getPgName() === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE) {
          productTypeForGoogleIAP = PRODUCT_TYPE_SUBSCRIPTION
        }
        const callbackParams = {
          next: 'setData',
          ...normalizePurchaseParams({ ...get(voucher, 'concurrency.0', {}), ...productInfo })
        }
        voucherPurchase({
          deviceType: this.device,
          productId: productId,
          callbackAction: 'purchaseComplete',
          callbackParams,
          canceledCallbackAction: 'Cancel',
          pgName: utils.getPgName(),
          productTypeForGoogleIAP
        })
      }
    },
    getValue (voucher, key) {
      return get(voucher, ['concurrency', '0', key], '')
    },
    getAmountDataValue (amountData, key) {
      return get(amountData, key, '')
    },
    moveToVoucherTab (voucherType) {
      this.$router.push('/voucher/index?voucherType=' + voucherType)
    },
    selectedTabClass (voucherType) {
      return this.voucherType === voucherType ? 'selected' : ''
    },
    purchaseAmountInfoList (voucher) {
      return get(voucher, 'concurrency.0.purchase_amount_info_list', [])
    },
    isRecommendation (voucher) {
      return this.getValue(voucher, 'recommendation')
    },
    isInUse (voucher) {
      return this.getValue(voucher, 'in_use')
    },
    isDiscount (amountData) {
      return this.getAmountDataValue(amountData, 'discount_rate') !== ''
    },
    isMonthAmount (amountData) {
      return this.getAmountDataValue(amountData, 'month_amount') !== ''
    },
    async postMessage (e) {
      if (e.origin === location.origin) {
        const { eventMessage, params = {} } = e.data
        if (eventMessage === 'purchaseComplete') {
          if (params.result === 'y') {
            braze.purchase(getPurchaseProperties(params))
          }
          const credential = utils.cookies.getCredential()
          const isMultiLine = Number(utils.cookies.userInfo('profilecount')) !== 1
          await utils.login.credentialAutoLogin(credential, isMultiLine, false)
          switch (params.next) {
            case 'reload':
              window.location.reload(true)
              break
            case 'setData':
              this.setData()
              break
            default:
              break
          }
        }
      }
    }
  },
  created () {
    this.setData()
  },
  mounted () {
    window.addEventListener('message', this.postMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.postMessage)
  },
  watch: {
    $route () {
      this.setData()
    }
  }
}
</script>
